import styled from 'styled-components';
import defaultBanner from 'assets/banner.jpg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 1.5rem 1rem 0;
  max-width: 1400px;
  @media (max-width: 670px) {
    padding: 0;
  }
`;

export const Banner = styled.img.attrs(({ $banner }) => ({
  src: $banner || defaultBanner,
}))`
  border-radius: 2rem;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  @media (max-width: 670px) {
    border-radius: 0;
  }
`;
